import { PostEntity } from '~/post/PostEntity';
import { getPostActionString } from '~/post/helpers';
import { RpcUpdate } from '~/post/types';
import { selectProfileTimezone } from '~/profile-sidebar/selectors';
import { useAppSelector } from '~/store';
import {
  selectUserId,
  selectHasTwentyFourHourTimeFormat,
} from '~/user/selectors';

type usePostDetailsResponse = {
  postAction: string | null;
  creatorName?: string;
  avatarUrl: string;
  createdAt: string;
  shopgridLink?: string;
  channel?: {
    avatarUrl: string;
    handle: string;
    type: string;
  };
  hideCreatorDetails?: boolean;
};

export const usePostDetails = (post: RpcUpdate): usePostDetailsResponse => {
  const userId = useAppSelector(selectUserId);
  const profileId = post?.profileId;
  const profileTimezone: string | null = useAppSelector((state) =>
    selectProfileTimezone(state, profileId)
  );
  const twentyFourHourTime: boolean = useAppSelector(
    selectHasTwentyFourHourTimeFormat
  );

  if (!post)
    return {
      postAction: '',
      creatorName: '',
      avatarUrl: '',
      createdAt: '',
      shopgridLink: '',
      channel: undefined,
      hideCreatorDetails: false,
    };

  const createdAtString = PostEntity.getFormatedCreatedAt(post, {
    twentyFourHourTime,
    timezone: profileTimezone,
  });

  return {
    postAction: getPostActionString({
      post,
      profileTimezone,
      twentyFourHourTime,
    }),
    creatorName: post.user?.id === userId ? 'You' : post.user?.name ?? '',
    avatarUrl: post?.user?.avatar ?? post?.user?.gravatar,
    createdAt: createdAtString,
    shopgridLink: post?.shopgridLink,
    channel: post?.headerDetails?.channel,
    hideCreatorDetails: post?.headerDetails?.hideCreatorDetails,
  };
};
